// 教学服务
import React, { useContext } from 'react';
import { useTranslation } from 'next-i18next';
import cls from 'classnames';
import Image from 'next/image';
import Button from '@/components/OldButton';
import Title from '@/components/Teachers/Title';
import PC from '@/components/Device/PC';
import Mobile from '@/components/Device/Mobile';
import { MyContext } from '@/config/context-manager';
import useGTM from '@/hooks/useGtag';
import styles from './style.module.scss';

const LIST_CONTENT = [1, 2, 3, 4, 5, 6];
const TeachingService = () => {
  const { t } = useTranslation(['teachers', 'path']);
  const { locale } = useContext(MyContext);
  const sendDataToGTM = useGTM();
  const handleGA = () => {
    sendDataToGTM('entry_teachers_lastscreen');
  };
  return (
    <section
      className={cls(styles.container, {
        [styles.localeEn]: locale === 'en',
      })}
    >
      <div className={styles.leftWrapper}>
        <div className={styles.leftContent}>
          <Title theme="allWhite" className={styles.title}>
            {t('教学服务-标题')}
          </Title>

          {locale === 'en' ? (
            <div className={styles.subTitle} dangerouslySetInnerHTML={{ __html: t('教学服务-副标题') }} />
          ) : (
            <>
              <p className={styles.subTitle} dangerouslySetInnerHTML={{ __html: t('教学服务-副标题') }} />
              <p className={styles.keywords}>{t('教学服务-关键字')}</p>
            </>
          )}
          <ul className={styles.describe}>
            {LIST_CONTENT.map((item) => (
              <li key={item}>{t(`教学服务-列表内容${item}`)}</li>
            ))}
          </ul>
        </div>
        <div className={styles.buttonWrapper}>
          <Button href="/independent-appointment" className={styles.button} theme="blue" size="l" onClick={handleGA}>
            {t('教学服务-按钮')}
          </Button>
        </div>
      </div>
      <PC>
        <div className={styles.rightContent}>
          <Image src="/images/teachers/teacher-service.png" layout="fill" objectFit="cover" alt={t('教学服务-alt')} />
        </div>
      </PC>
      <Mobile>
        <div className={styles.bottomContent}>
          <Image
            src="/images/teachers/teacher-service-mobile-figure.png"
            layout="fill"
            objectFit="cover"
            alt={t('教学服务-alt')}
          />
        </div>
      </Mobile>
    </section>
  );
};

export default TeachingService;
